import { render, staticRenderFns } from "./LoadingAfipTicket.vue?vue&type=template&id=06fb5736&"
import script from "./LoadingAfipTicket.vue?vue&type=script&lang=js&"
export * from "./LoadingAfipTicket.vue?vue&type=script&lang=js&"
import style0 from "./LoadingAfipTicket.vue?vue&type=style&index=0&id=06fb5736&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports